import { Box, Checkbox, TableRow } from "@mui/material";
import { Dispatch, Fragment, SetStateAction } from "react";
import { calculateTotalDuration } from "../../../app/common";
import { getUniqueExpenses } from "../EntriesList";
import { Entry } from "../entriesAPI";
import { EntriesTableCell } from "../styles";
import { CollabsibleStates, GroupedData, Refs } from "../types";
import CollapsibleHeaders from "./CollapsibleHeaders";
import EntriesGroupHeader from "./EntriesGroupHeader";
import ExpandCollapseButton from "./ExpandCollapseButton";

type Props = {
  firstGroupingLevelLabels: string[];
  groupData: any;
  groupLabel: string;
  setColabsibleStates: Dispatch<SetStateAction<CollabsibleStates>>;
  selectedEntries: Entry[];
  collabsibleStates: CollabsibleStates;
  renderTable: (data: any) => JSX.Element[] | undefined;
  handleSelectGroupEntries: (
    groupData: GroupedData,
    groupLabel: string,
    checked: boolean,
  ) => void;
  headers: {
    supplementHeaders: string[];
    supplementsHeaderRefs: Refs<any[]>;
    expensesHeaders: string[];
    expensesHeaderRefs: Refs<any[]>;
  };
};

const GroupRow = ({
  firstGroupingLevelLabels,
  groupData,
  groupLabel,
  setColabsibleStates,
  selectedEntries,
  collabsibleStates,
  renderTable,
  handleSelectGroupEntries,
  headers,
}: Props) => {
  const isFirstGroupingLevel = firstGroupingLevelLabels.includes(groupLabel);

  /*
      const entrySupplements = Array.isArray(groupData)
        ? getUniqueObjectKeys(groupData, "supplements")
        : [];
    
    
      const handleToggleSupplements = () =>
        // TODO: test if this works
        setColabsibleStates({
          ...collabsibleStates,
          supplementsOpen: !collabsibleStates.supplementsOpen,
        });
        */

  const entryExpenses = Array.isArray(groupData)
    ? getUniqueExpenses(groupData)
    : [];

  const handleToggleExpenses = () =>
    setColabsibleStates({
      ...collabsibleStates,
      expensesOpen: !collabsibleStates.expensesOpen,
    });

  let checked = false;
  let groupHours = null;

  if (Array.isArray(groupData)) {
    checked = groupData.every((entry) =>
      selectedEntries.some((selectedEntry) => selectedEntry.id === entry.id),
    );
    groupHours = calculateTotalDuration(groupData);
  } else {
    const entries = Object.values(groupData).flat() as Entry[];
    checked = entries.every((entry) =>
      selectedEntries.some((selectedEntry) => selectedEntry.id === entry.id),
    );
  }

  return (
    <Fragment key={groupLabel}>
      <TableRow
        sx={{
          backgroundColor: isFirstGroupingLevel ? "#fff" : "#F0EBF6",
        }}
      >
        <EntriesTableCell colSpan={4} noBorder verticalAlign="middle">
          <Box sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
            <Checkbox
              checked={checked}
              sx={{ padding: 0 }}
              onChange={() =>
                handleSelectGroupEntries(groupData, groupLabel, checked)
              }
            />
            <EntriesGroupHeader
              label={groupLabel}
              groupData={groupData}
              isFirstGroupingLevel={isFirstGroupingLevel}
            />
            {groupHours && (
              <EntriesGroupHeader
                label={groupHours}
                sx={{ marginLeft: "auto" }}
              />
            )}
          </Box>
        </EntriesTableCell>
        {/*
    <ExpandCollapseButton
          isFirstGroup={isFirstGroupingLevel}
          onClick={handleToggleSupplements}
          open={collabsibleStates.supplementsOpen}
        />
        <CollapsibleHeaders
          open={collabsibleStates.supplementsOpen}
          isFirstGroup={isFirstGroupingLevel}
          allHeaders={headers.supplementHeaders}
          entryHeaders={entrySupplements}
          refs={headers.supplementsHeaderRefs}
        />
          */}

        <ExpandCollapseButton
          isFirstGroup={isFirstGroupingLevel}
          onClick={handleToggleExpenses}
          open={collabsibleStates.expensesOpen}
        />
        <CollapsibleHeaders
          open={collabsibleStates.expensesOpen}
          isFirstGroup={isFirstGroupingLevel}
          allHeaders={headers.expensesHeaders}
          entryHeaders={entryExpenses}
          refs={headers.expensesHeaderRefs}
        />
        <EntriesTableCell colSpan={2}></EntriesTableCell>
      </TableRow>
      {renderTable(groupData)}
    </Fragment>
  );
};

export default GroupRow;
